import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public PurchaseOrders: PurchaseOrders_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

